import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowUpRight } from 'react-icons/fi';

const ToolCard = ({ icon, name, description, url, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      className="group p-6 bg-white border border-zinc-200 rounded-xl hover:border-zinc-400 hover:shadow-sm transition-all duration-300"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="w-10 h-10 rounded-lg bg-zinc-50 flex items-center justify-center border border-zinc-100 group-hover:bg-zinc-950 group-hover:text-white transition-colors duration-300">
          <SafeIcon icon={icon} className="w-5 h-5" />
        </div>
        <a 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-zinc-400 hover:text-zinc-950 transition-colors"
        >
          <SafeIcon icon={FiArrowUpRight} className="w-5 h-5" />
        </a>
      </div>
      
      <h3 className="text-lg font-bold text-zinc-950 mb-2">{name}</h3>
      <p className="text-sm text-zinc-500 leading-relaxed mb-6 line-clamp-2">
        {description}
      </p>
      
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-flex items-center text-xs font-bold uppercase tracking-wider text-zinc-950 group-hover:translate-x-1 transition-transform duration-300"
      >
        Try {name} &rarr;
      </a>
    </motion.div>
  );
};

export default ToolCard;